import { render, staticRenderFns } from "./BlueskyModal.vue?vue&type=template&id=b8138a90&scoped=true&"
import script from "./BlueskyModal.vue?vue&type=script&lang=js&"
export * from "./BlueskyModal.vue?vue&type=script&lang=js&"
import style0 from "./BlueskyModal.vue?vue&type=style&index=0&id=b8138a90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8138a90",
  null
  
)

export default component.exports